import type { PipelineDiagnostic, TerminalOutcome } from "./audio-pipeline.types";

/**
 * Result shape every stage adapter returns. The pipeline walks advance the
 * stage machine on `ok`, or call `finishWithOutcome` on failure. Keeping this
 * uniform means the walk code has no per-stage branching.
 */
export type StageResult =
  | { ok: true }
  | { ok: false; outcome: TerminalOutcome; diagnostic: PipelineDiagnostic };

export const okResult = (): StageResult => ({ ok: true });

export const failResult = (
  outcome: TerminalOutcome,
  diagnostic: PipelineDiagnostic
): StageResult => ({
  ok: false,
  outcome,
  diagnostic,
});
